import { cn } from '@1trading/react';
import type { ReactNode } from 'react';

export interface DetailListItem {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

interface DetailListProps {
  items: readonly DetailListItem[];
  className?: string;
}

/** Bordered label/value list for read-only record data. */
export const DetailList = ({ items, className }: DetailListProps) => (
  <dl className={cn('divide-y overflow-hidden rounded-lg border bg-card text-sm', className)}>
    {items.map((item) => (
      <div className="grid gap-1 px-4 py-2.5 sm:grid-cols-[minmax(10rem,14rem)_minmax(0,1fr)] sm:gap-4" key={item.key}>
        <dt className="text-muted-foreground">{item.label}</dt>
        <dd className="min-w-0 break-words">{item.value}</dd>
      </div>
    ))}
  </dl>
);
DetailList.displayName = 'DetailList';
